var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCreditCard, faHandsHoldingDollar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { fontWeights, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../theme';
var DisputesTransactionTypeContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n"])));
var DisputesTransactionIcon = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  width: 24px;\n  height: 24px;\n"], ["\n  color: ", ";\n  width: 24px;\n  height: 24px;\n"])), theme.pallete.icon);
var DisputesTransactionTypeText = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin-top: ", "px;\n  font-size: 10px;\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  margin-top: ", "px;\n  font-size: 10px;\n  font-weight: ", ";\n"])), theme.colors.denimBlue, spacing.xsmall, fontWeights.semiBold);
var TransactionTypeIcons = {
    PURCHASE: faCreditCard,
    REFUND: faHandsHoldingDollar
};
var DisputesTransactionTypeIcon = function (_a) {
    var className = _a.className, title = _a.title, type = _a.type;
    var icon = type ? TransactionTypeIcons[type] : faCreditCard;
    return (_jsxs(DisputesTransactionTypeContainer, __assign({ className: className }, { children: [_jsx(DisputesTransactionIcon, { icon: icon }), _jsx(DisputesTransactionTypeText, { children: title })] })));
};
export default DisputesTransactionTypeIcon;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map